<template>
  <div class="toast" :class="{show: visible}">
    <span class="tdot"></span>
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'AppToast',
  computed: {
    visible() { return this.$store.state.ui.toast.visible; },
    message() { return this.$store.state.ui.toast.message; },
  },
};
</script>
